export default function BrandCapitalSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-[#E879F9]/10 rounded-full mb-4 sm:mb-6">
              <span className="text-sm font-semibold text-[#E879F9]">Il Sistema</span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight text-left">
              Brand Capital
            </h2>
            <div className="space-y-4 sm:space-y-5 text-sm sm:text-base text-[#1C1C1C]/80 leading-relaxed">
              <p>
                <strong className="text-[#0B1F3B]">Brand Capital è un sistema progettato per consentire alle aziende di trattare il brand come un asset economico</strong>, e non come un semplice elemento di comunicazione o marketing.
              </p>
              <p>
                Nella maggior parte delle imprese il brand esiste, genera effetti economici, ma: <strong>non è misurato, non è governato, non è documentato, non è separabile</strong> dalla persona o dall'operatività.
              </p>
              <p>
                Brand Capital nasce per colmare questo vuoto, introducendo un <strong className="text-[#0B1F3B]">approccio strutturato alla misurazione e alla gestione del valore del brand</strong>, compatibile con le esigenze imprenditoriali, strategiche e decisionali.
              </p>
              <p>
                Brand Capital vende un sistema integrato di strumenti, modelli e processi che consente di:
              </p>
              <ul className="space-y-2 sm:space-y-3 ml-4 sm:ml-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#22C55E] text-lg sm:text-xl mr-2 sm:mr-3 mt-1"></i>
                  <span>Misurare il valore economico del brand</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#22C55E] text-lg sm:text-xl mr-2 sm:mr-3 mt-1"></i>
                  <span>Documentare tale valore in modo strutturato</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#22C55E] text-lg sm:text-xl mr-2 sm:mr-3 mt-1"></i>
                  <span>Governare nel tempo le decisioni che incidono sul capitale di brand</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#22C55E] text-lg sm:text-xl mr-2 sm:mr-3 mt-1"></i>
                  <span>Ridurre il rischio legato alla gestione degli asset immateriali</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[300px] sm:h-[400px] lg:h-[480px]">
                <img
                  src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/a09f227ec11485c0a10018256f016cc7.png"
                  alt="Brand Capital System"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#E879F9]/10 rounded-full blur-2xl"></div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#22C55E]/10 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
